import { IPayload } from 'models/Global'
import {
  IGetDashboardParams,
  IDashboardData,
  IGetAmOverviewParams,
  IAmOverviewData,
  IGetAmDashboardRegionsParams,
  IRegionsData,
  IGetShiftsParams,
  IShiftsData,
} from 'models/AccountManagerDashboard'
import { AxiosService } from '../config/config'
import { Endpoints } from '../config/endpoints'

export class AccountManagerDashboardApi {
  constructor(private axios: AxiosService) {}

  getDashboard = async (params: IGetDashboardParams) => {
    const response = await this.axios.get<IPayload<IDashboardData>>(
      Endpoints.getAccountManagerDashboard,
      params
    )
    return response
  }

  getAccountManagersOverview = async (params: IGetAmOverviewParams) => {
    const response = await this.axios.get<IPayload<IAmOverviewData>>(
      Endpoints.getAccountManagerDashboardAccountManagers,
      params
    )
    return response
  }

  getRegions = async (params?: IGetAmDashboardRegionsParams) => {
    const response = await this.axios.get<IPayload<IRegionsData>>(
      Endpoints.getAccountManagerDashboardRegions,
      params
    )
    return response
  }

  getShifts = async (params: IGetShiftsParams) => {
    const response = await this.axios.get<IPayload<IShiftsData>>(
      Endpoints.getAccountManagerDashboardShifts,
      params
    )
    return response
  }
}
